// Pinata IPFS upload utilities
// Uploads are now handled securely via serverless function

const UPLOAD_API_URL = "/api/upload-to-pinata";

// Helper function to convert blob to base64
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const uploadImageToPinata = async (blob, filename = "ticket.png") => {
  try {
    // Convert blob to base64 for transmission to API
    const fileData = await blobToBase64(blob);

    const response = await fetch(UPLOAD_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileData,
        fileName: filename,
        fileType: blob.type,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Image upload failed: ${errorData.error}`);
    }

    const data = await response.json();
    return data.ipfsUri;
  } catch (error) {
    console.error('Pinata image upload error:', error);
    throw error;
  }
};

export const uploadMetadataToPinata = async (metadata, filename = "metadata.json") => {
  try {
    const blob = new Blob([JSON.stringify(metadata, null, 2)], {
      type: "application/json",
    });

    // Convert blob to base64 for transmission to API
    const fileData = await blobToBase64(blob);

    const response = await fetch(UPLOAD_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileData,
        fileName: filename,
        fileType: "application/json",
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Metadata upload failed: ${errorData.error}`);
    }

    const data = await response.json();
    return data.ipfsUri;
  } catch (error) {
    console.error('Pinata metadata upload error:', error);
    throw error;
  }
};
